import React from 'react';
import { DeleteEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as DeleteIcon } from '../../../../resources/assets/components/DLS_DeleteTrash.svg';
import { ReactComponent as DetailsIcon } from '../../../../resources/assets/components/DLS_InformationCircle.svg';
import { ReactComponent as DownloadIcon } from '../../../../resources/assets/components/DLS_ReadyToDownload.svg';
import { downloadImage } from '../../media-container/media-container-utils.js';
import './gallery-hover.css';
function Details(props) {
    if (!props.image) {
        return null;
    }
    const onClick = () => {
        if (isFunction(props.onMouseLeave)) {
            props.onMouseLeave();
        }
        props.onDetailsClick();
    };
    return React.createElement(DetailsIcon, { className: "c-gallery-hover__svg", onClick: onClick });
}
function Download(props) {
    const { image = '' } = props;
    if (!image) {
        return null;
    }
    return React.createElement(DownloadIcon, { className: "c-gallery-hover__svg", onClick: () => void downloadImage(image) });
}
function Delete(props) {
    if (!isFunction(props.onDelete)) {
        return null;
    }
    return React.createElement(DeleteIcon, { className: "c-gallery-hover__svg", onClick: () => props.onDelete(new DeleteEvent({ id: props.id })) });
}
function GalleryHover(props) {
    return (React.createElement("div", { className: "c-gallery-hover", onMouseLeave: props.onMouseLeave },
        React.createElement(Details, { image: props.image, onDetailsClick: props.onDetailsClick, onMouseLeave: props.onMouseLeave }),
        React.createElement(Download, { image: props.image }),
        React.createElement(Delete, { id: props.id, onDelete: props.onDelete })));
}
export { GalleryHover, };
//# sourceMappingURL=gallery-hover.js.map